import { render, staticRenderFns } from "./unifromOrder.vue?vue&type=template&id=8c559860&scoped=true&"
import script from "./unifromOrder.vue?vue&type=script&lang=js&"
export * from "./unifromOrder.vue?vue&type=script&lang=js&"
import style0 from "./unifromOrder.vue?vue&type=style&index=0&id=8c559860&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c559860",
  null
  
)

export default component.exports